import * as React from 'react';
import { Field } from 'redux-form';
import { II18nMessages } from '../../../../../../services/branding/models';
import { Button, Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import SelectControl from '../../../../../../components/SelectControl';
import FaTrash from 'react-icons/fa/trash';
import { IChannel, IDestination } from '../../../../../../data/api/models';
import { isRequired } from '../../../../../../util/validators';
import { filter } from 'lodash';

interface ITripDetailsForm {
  i18n: II18nMessages;
  destinations: IDestination[];
  destinationsValue: string[];
  renderDefinition(name: string): any;
  pristine: boolean;
  fields: any;
  channel: IChannel;
}

class Destination extends React.Component<ITripDetailsForm> {
  private addField = () => {
    const { fields } = this.props;

    fields.push('');
  }

  private deleteField = (index) => () => {
    const { fields } = this.props;

    fields.remove(index);
  }

  private renderFields() {
    const { fields, destinations, destinationsValue, channel } = this.props;

    const destinationsListFiltered = filter(destinations, (destination) => destination.included === true);

    const destinationsList = destinationsListFiltered
      .filter((destination) => {
        return !(channel.key !== 'fst-b2c' && destination.name === 'Schengen Area');
      })
      .map((destination) => ({
        label: destination.name,
        value: destination.name,
        disabled: destinationsValue.indexOf(destination.name) > -1,
      }));

    return fields.map((destination, index) => {
      const columns = {
        first: {
          field: {
            xs: 12,
          },
          btn: {
            xs: 0,
            className: 'hidden',
          },
        },
        normal: {
          field: {
            xs: 9,
            sm: 10,
            md: 10,
            lg: 10,
          },
          btn: {
            xs: 3,
            sm: 2,
            md: 2,
            lg: 2,
          },
        },
      };
      const colConfig = columns[index === 0 ? 'first' : 'normal'];

      return (
        <Row key={index}>
          <Col {...colConfig.field}>
            <Field
              name={destination}
              options={destinationsList}
              component={SelectControl}
              validate={[isRequired]}
            />
          </Col>
          <Col {...colConfig.btn}>
            <Button bsStyle="link" onClick={this.deleteField(index)}>
              <div className="remove-icon"><FaTrash /></div>
            </Button>
          </Col>
        </Row>
      );
    });
  }

  public componentWillMount() {
    if (this.props.fields.length === 0) {
      this.addField();
    }
  }

  public render() {
    const { i18n, channel, destinationsValue} = this.props;

    let showSchengenRegionText = false;

    if (destinationsValue.includes('Schengen Area')) {
      showSchengenRegionText = true;
    }

    return (
      <div>
        <Row>
          <Col sm={12}>
            <FormGroup controlId="destination">
              <Col sm={12} className="destinations-inputs">
                {this.renderFields()}
              </Col>
            </FormGroup>
          </Col>
        </Row>
        <Button bsStyle="primary" onClick={this.addField}>
          {i18n.quote.tripDetails.addCountry}
        </Button>
        {channel.key === 'fst-b2c' && showSchengenRegionText && (
          <p style={{ fontSize: '14px', marginTop: '10px' }}>
            If you need cover for all destinations within the Schengen Area, please select ‘Schengen Area’ from the
            list.
            Your policy schedule will then show all destinations within the Schengen Area. For further information on
            Schengen travel requirements, you can visit the Gov.uk website here: <a
            href="https://www.gov.uk/travel-to-eu-schengen-area" target="_blank">
            https://www.gov.uk/travel-to-eu-schengen-area</a>
          </p>
        )}

      </div>
    );
  }
}

export default Destination;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/components/Destination/index.tsx